import { useGetAssessmentResult } from "@/api/console/assessment-results/useGetAssessmentResult";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button";
import useProfile from "@/hooks/useProfile";
import download from "@/lib/download";
import { handleCompanyName } from "@/lib/handleName";
import { handlePrintPdf } from "@/lib/handlePrintPdf";
import AssessmentResult from "@/src/_components/AssessmentResult/AssessmentResult";
import UpdateCompanyStatusDialog from "@/src/console/(auth)/assessment-results/[id]/_components/UpdateCompanyStatusDialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

function ConsoleAssessmentResultDownloadPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const [searchParams] = useSearchParams();
  const isFirstTime = searchParams.get("isFirstTime") === "true";
  const { data, isLoading } = useGetAssessmentResult(id, isFirstTime);
  const [isPrinting, setPrinting] = useState(false);
  const [isDownloading, setDownloading] = useState(false);
  const { isRoleZero } = useProfile();
  const [open, setOpen] = useState(false);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!data) {
    navigate("/console/all-assessments");
    return null;
  }
  const {
    id: companyId,
    company: { company_name, has_improvement_proposal, status },
    result,
    updated_at,
  } = data.data;

  const hasImprovementProposal = has_improvement_proposal ?? false;

  return (
    <div className="h-full overflow-auto">
      <div className="flex justify-between px-16 py-4 border-b border-cool-gray-200">
        <span className="text-2xl font-bold">{t("assessment-result")}</span>
        <div className="flex gap-2">
          {!isRoleZero && (
            <Button onClick={() => setOpen(true)}>{t("update-status")}</Button>
          )}
          <Button
            isLoading={isPrinting}
            variant="outline"
            onClick={() => {
              setPrinting(true);
              handlePrintPdf("assessment-result", "assessment-result", () => {
                setPrinting(false);
              });
            }}
          >
            {t("download-report")}
          </Button>
          <Button
            disabled={isDownloading}
            onClick={async () => {
              setDownloading(true);
              await download(
                `/console/assessment_results/${id}/download?is_first_time=${isFirstTime}`,
              ).then(() => {
                setDownloading(false);
              });
            }}
          >
            {t("download-excel")}
          </Button>
        </div>
      </div>
      <AssessmentResult assessmentResult={data.data} />;
      <UpdateCompanyStatusDialog
        companyId={companyId}
        companyName={handleCompanyName(companyId, company_name)}
        status={status}
        hasImprovementProposal={hasImprovementProposal}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
}

export default ConsoleAssessmentResultDownloadPage;
